module.exports = __webpack_public_path__ + "img/empty.34e852d6.png";